import { NumericFeatureIds, RangeIds } from "./rangeIds";
import { SeverityQuestion } from "./rangeQuestionComponents/severityQuestion";
import { FeverQuestion } from "./numericQuestions/feverQuestion";
import { RangeQuestionsMetaData } from "./rangeQuestionsMetaData";
import { BloodPressureQuestion } from "./numericQuestions/bloodPressureQuestion";
import { WeightQuestion } from "./numericQuestions/weightQuestion";
import { HeightQuestion } from "./numericQuestions/heightQuestion";
import { SmokingQuestion } from "./numericQuestions/smokingQuestion";
import { GeneralNumericQuestion } from "./numericQuestions/generalNumericQuestion";

/***
 * Here we define all unique ui controllers for specific range
 * (like severity) which are used to represent a completed ui
 * tailor-made for a specific range (which isn't a body location diagram)
 */
export const RangeQuestionsIndex: RangeQuestionsMetaData[] = [
  {
    name: "Severity Questions",
    rangeId: RangeIds.Severity,
    component: SeverityQuestion,
  },
  {
    name: "Fever",
    rangeId: RangeIds.Numeric,
    featureId: NumericFeatureIds.Fever,
    component: FeverQuestion,
  },
  {
    name: "Blood Pressure",
    rangeId: RangeIds.Numeric,
    featureId: NumericFeatureIds.SystolicBloodPressure,
    component: BloodPressureQuestion,
  },
  {
    // We get two suggestions in blood pressure, if we get either in suggestions[0]
    // render the same component
    name: "Blood Pressure",
    rangeId: RangeIds.Numeric,
    featureId: NumericFeatureIds.DiastolicBloodPressure,
    component: BloodPressureQuestion,
  },
  {
    name: "Smoking",
    rangeId: RangeIds.Numeric,
    featureId: NumericFeatureIds.Smoking,
    component: SmokingQuestion,
  },
  {
    name: "Weight",
    rangeId: RangeIds.Numeric,
    featureId: NumericFeatureIds.Weight,
    component: WeightQuestion,
  },
  {
    name: "Height",
    rangeId: RangeIds.Numeric,
    featureId: NumericFeatureIds.Height,
    component: HeightQuestion,
  },
  /**
   * NOTE: order is crucial here, as the earlier components will try to match
   * first, this component will only match if none of the previous `featureIds`
   * matched. make sure to add new feature types above this component in the array
   * otherwise you will always see the slider ;)
   * see: rangeQuestion.tsx
   **/
  {
    // General numeric questions gets a slider.
    name: "General numeric range",
    rangeId: RangeIds.Numeric,
    component: GeneralNumericQuestion,
  },
];
